import React, { Component } from 'react'
import Dialog from "@material-ui/core/Dialog"
import './BusinessAccount.scss'
import AccountEdit from './AccountListDialog/AccountEdit'
import TwoBtnDialog from '../../Common/TwoBtnDialog/TwoBtnDialog'
import OneBtnDialog from "../../Common/OneBtnDialog/OneBtnDialog";

import i18n from '../../i18n';
import axios from "axios";
import { GetBaseUrl } from '@/utils/ConfigHelper'
import dayjs from 'dayjs'

import { connect } from 'react-redux'

class BusinessAccount extends Component {

    constructor(props) {
        super(props)
        this.state = {
            accountList: [],
            accountData: {},
            isCreateAccount: false,
            isOpenAccountEdit: false,
            isOpenRemoveAccount: false,
            twoBtnDialog: {
                isOpen: false,
                headerLabel: '',
                onClickCloseBtn: null,
                onClickCancelBtn: null,
                onClickConfirmBtn: null,
                cancelBtnLabel: '',
                confirmBtnLabel: '',
                body: null
            },
            dialogType: "removeAccount",
            isOpenOneBtnDialog: false,
            nickname: '',
            password: '',
            passwordAlertMessage: '',
            nicknameAlertMessage: '',
            nicknameValid: false,
            passwordValid: false
        }
    }

    isValidPassword = password => /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,32}$/.test(String(password).toLowerCase())

    componentDidMount() {
        this.getAccountData()
    }

    getAccountData = async () => {
        const token = localStorage.getItem('token')

        try {
            const response = await axios.get(`${GetBaseUrl()}/apis/users/business/accounts`, { headers: { Authorization: `Bearer ${token}` } })
            this.setState({ accountList: response.data.data })
        } catch (e) {
            console.log(e)
        }
    }

    handleClickDeactiveCreateBtn = () => this.setState({ isCreateAccount: false, dialogType: "businessMaxiumAccountAlert", isOpenOneBtnDialog: true })

    handleClickCreateAccount = () => this.setState({
        isCreateAccount: true,
        nickname: '',
        password: '',
        passwordAlertMessage: '',
        nicknameAlertMessage: '',
        nicknameValid: false,
        passwordValid: false,
    })
    handleClickCloseCreateAccount = () => this.setState({
        isCreateAccount: false,
        password: '',
    })
    handleClickCreateButton = async () => {
        const { nickname, password } = this.state
        const token = localStorage.getItem('token')

        try {
            await axios.post(`${GetBaseUrl()}/apis/users/business/account`, { password: password, displayName: nickname }, { headers: { Authorization: `Bearer ${token}` } })
            this.getAccountData()
            this.setState({ isCreateAccount: false, dialogType: "createAccount", isOpenOneBtnDialog: true })
        }
        catch (e) {
            if (e.response.data && e.response.data.error_code) {
                if (e.response.data.error_code === "ERR_EXCEED") 
                    return this.setState({ isCreateAccount: false, dialogType: "businessMaxiumAccountAlert", isOpenOneBtnDialog: true })
            }
            
            this.setState({ isCreateAccount: false, dialogType: "severError", isOpenOneBtnDialog: true })
        }
    }

    handleClickCloseDialog = () => {
        const { onClose } = this.props
        onClose()
        this.setState({
            isCreateAccount: false,
            passwordAlertMessage: '',
            nicknameAlertMessage: '',
            password: '',
            nicknameValid: false,
            passwordValid: false
        })

    }

    handleClickAccountEdit = (item) => {
        this.setState({ isOpenAccountEdit: true, accountData: item })
    }
    handleClickCloseAccountEdit = () => this.setState({ isOpenAccountEdit: false })

    handleTwoButtonDialogClose = () => {
        const { twoBtnDialog } = this.state
        twoBtnDialog.isOpen = false
        this.setState({ twoBtnDialog })
    }

    handleRemoveAccountDialogOpen = item => {
        this.setState({
            twoBtnDialog: {
                isOpen: true,
                headerLabel: '',
                onClickCloseBtn: this.handleTwoButtonDialogClose,
                onClickCancelBtn: this.handleTwoButtonDialogClose,
                onClickConfirmBtn: this.handleRemoveAccountButton,
                cancelBtnLabel: '',
                confirmBtnLabel: '',
                body: i18n.t("twoBtndialog.remove.account")
            },
            accountData: item
        })
    }

    handleOneButtonDialogClose = () => this.setState({ isOpenOneBtnDialog: false })
    handleRemoveAccountButton = async () => {
        const { accountData } = this.state
        const token = localStorage.getItem('token')

        try {
            await axios.delete(`${GetBaseUrl()}/apis/users/business/account/${accountData._id}`, { headers: { Authorization: `Bearer ${token}` } })
            this.getAccountData()
            this.setState({ dialogType: "removeAccount", isOpenOneBtnDialog: true, twoBtnDialog: { isOpen: false } })
        } catch (e) {
            console.log(e)
            this.setState({ dialogType: "severError" })
        }
    }

    handleChangeInput = e => {
        this.setState({
            [e.target.name]: e.target.value,
        })
    }

    handleBlurNicknameInput = async e => {
        const { value } = e.target
        let alertString = null
        let nicknameValid = false

        try {
            if (!value || value.length === 0) {
                alertString = i18n.t("web.business.account.nickname.check")
            } 
            else if (value.includes(' ')) {
                alertString = i18n.t("web.business.account.space")
            } 
            else {
                const response = await axios.get(`${GetBaseUrl()}/api/auth/is-exist-email?email=${value}`)
                if (response.data.isExist) {
                    alertString = i18n.t("web.business.account.duplicate")
                }
            }

            if (alertString === null) {
                nicknameValid = true
            } 
            else {
                nicknameValid = false
            }

        } catch (e) {
            console.log(e)
        }
        this.setState({ nicknameAlertMessage: alertString, nicknameValid })
    }

    handleBlurPasswordInput = async e => {
        const { value } = e.target
        const { password } = this.state
        let alertString = null
        let passwordValid = false

        if (!value || value.length === 0) {
            alertString = i18n.t("web.business.account.password.check")
        } 
        else if (!this.isValidPassword(password)) {
            alertString = i18n.t("web.business.wrong.password")
        }

        if (alertString === null) {
            passwordValid = true
        } 
         else {
            passwordValid = false
        }

        this.setState({ passwordAlertMessage: alertString, passwordValid })
    }

    renderAccountList = () => {
        const { accountList } = this.state
        return accountList.map(item =>
        (
            <div className='account-list-item'>
                <span className='account-name'>{item.Email}</span>
                <span className='account-date'>{dayjs(item.createdAt).format("YY.MM.DD")}</span>
                <span className='account-edit'>
                    <div className='edit-button' onClick={() => this.handleClickAccountEdit(item)}>{i18n.t("web.business.account.edit")}</div>
                    <div className='delete-button' onClick={() => this.handleRemoveAccountDialogOpen(item)}>{i18n.t("web.business.account.delete")}</div>
                </span>
            </div>
        ))
    }

    render() {
        const { open, paymentMode } = this.props
        const {
            isCreateAccount,
            isOpenAccountEdit,
            twoBtnDialog,
            isOpenOneBtnDialog,
            dialogType,
            nickname,
            password,
            accountData,
            passwordAlertMessage,
            nicknameAlertMessage,
            nicknameValid,
            passwordValid,
            accountList
        } = this.state

        const isValidBtn = nicknameValid && passwordValid
        const maxAccountValue = paymentMode && paymentMode.product ? paymentMode.product.maxAccount : 0
        const isCreateActive = accountList.length + 1 >= maxAccountValue    // true : 비활성화, false : 활성화

        return (
            <Dialog open={open} onClose={() => this.handleClickCloseDialog()} maxWidth={false}>
                <div className='business-account-container'>
                    <div className='business-account-title'>{i18n.t("web.business.account.management.title")}</div>
                    <div className='business-account-close'>
                        <img src='https://front.videomonster.com/images-7cuytg20/web/newgallery/DialogClose.svg' onClick={this.handleClickCloseDialog} alt='close' />
                    </div>
                    <div className='business-account-body'>
                        <div className='account-list-area'>
                            {
                                isCreateAccount ?
                                    <div className='account-create'>
                                        <div className='account-create-title'>{i18n.t("web.business.account.new.created")}</div>
                                        <div className='account-input-area'>
                                            <input
                                                className='nickname'
                                                type='text'
                                                name='nickname'
                                                value={nickname}
                                                placeholder={i18n.t("web.business.account.placeholder.nickname")}
                                                spellcheck="false"
                                                onChange={this.handleChangeInput}
                                                onBlur={this.handleBlurNicknameInput}
                                            />
                                            {
                                                nicknameAlertMessage
                                                    ?
                                                    <div className='input-bottom-text'>{nicknameAlertMessage}</div>
                                                    :
                                                    <div className='spacer'></div>
                                            }
                                            <input
                                                className='password'
                                                type='password'
                                                name='password'
                                                value={password}
                                                placeholder={i18n.t("web.business.account.placeholder.password")}
                                                spellcheck="false"
                                                onChange={this.handleChangeInput}
                                                onBlur={this.handleBlurPasswordInput}
                                            />
                                            {
                                                passwordAlertMessage
                                                    ?
                                                    <div className='input-bottom-text'>{passwordAlertMessage}</div>
                                                    :
                                                    <div className='spacer'></div>
                                            }
                                        </div>
                                        <div className='create-button-area'>
                                            <div className={`create-button ${isValidBtn ? 'active' : ''}`} onClick={() => isValidBtn && this.handleClickCreateButton()}>{i18n.t("web.business.account.done.created")}</div>
                                            <div className='cancel-button' onClick={this.handleClickCloseCreateAccount}>{i18n.t("web.business.account.cancel")}</div>
                                        </div>
                                    </div>
                                    :
                                    ''
                            }
                            <div className='account-list-title'>
                                <p>{i18n.t("web.business.account.list")}</p>
                                <p>({(accountList.length + 1)} / {maxAccountValue})</p>
                                <p className='notice'>* {i18n.t("web.business.account.notice")}</p>
                            </div>
                            <div className='account-list-item-title'>
                                <span className='nickname'>{i18n.t("web.business.account.nickname")}</span>
                                <span className='createdDate'>{i18n.t("web.business.account.date")}</span>
                                <span className='edit'>{i18n.t("web.business.account.modify")}</span>
                            </div>
                            <div className='account-list-item-area'>{this.renderAccountList()}</div>
                        </div>
                        <div className='account-create-area'>
                            {
                                isCreateAccount ?
                                    ''
                                    :
                                    <div 
                                        className={`account-create-button ${isCreateActive && 'deactive'}`} 
                                        onClick={isCreateActive ? this.handleClickDeactiveCreateBtn : this.handleClickCreateAccount}
                                    >
                                            {i18n.t("web.business.account.created")}
                                    </div>
                            }
                        </div>
                    </div>
                    <AccountEdit
                        open={isOpenAccountEdit}
                        onClose={this.handleClickCloseAccountEdit}
                        accountData={accountData}
                        getAccountData={this.getAccountData}
                    />

                    <TwoBtnDialog
                        open={twoBtnDialog.isOpen}
                        header={twoBtnDialog.headerLabel}
                        closeBtn={twoBtnDialog.onClickCloseBtn}
                        onClose={twoBtnDialog.onClickCancelBtn}
                        onClick={twoBtnDialog.onClickConfirmBtn}
                        confirmBtnLabel={twoBtnDialog.confirmBtnLabel}
                        cancelBtnLabel={twoBtnDialog.cancelBtnLabel}
                    >
                        {twoBtnDialog.body}
                    </TwoBtnDialog>

                    <OneBtnDialog
                        dialogType={dialogType}
                        open={isOpenOneBtnDialog}
                        closeBtn={this.handleOneButtonDialogClose}
                        onButtonClick={this.handleOneButtonDialogClose}
                    />
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
    paymentMode: state.paymentModeStore.paymentMode
  })
  
export default connect(mapStateToProps, null)(BusinessAccount)